import React from "react";
import { MultiOrbitSpinner3 } from "../../lib/myIcons";

export default function OverlayLoader({
  text = "",
  spinner = true,
  color = "white",
  background = "rgba(0,0,0,0.4)",
  position = "absolute", // "absolute" | "fixed" | "sticky"
  top,
  bottom,
  style = {},
  height="100%"
}) {
  // Correct position mappings
  const positions = {
    absolute: {
      position: "absolute",
      top: top ?? 0,
      bottom: bottom ?? 0,
      left: 0,
      right: 0,
    },
    fixed: {
      position: "fixed",
      top: top ?? 0,
      bottom: bottom ?? 0,
      left: 0,
      right: 0,
    },
    sticky: {
      position: "sticky",

      // ❗ Sticky requires bottom anchor, not top!
      bottom: bottom ?? 0,
      left: 0,
      right: 0,

      // Prevent sticky from being pushed offscreen
      // If developer adds a top offset, we respect it,
      // but by default sticky bottom does not use top.
      ...(top !== undefined ? { top } : {}),
    },
  };

return (
 <div style={{ ...positions[position], zIndex: 9999, pointerEvents: "none", display:"flex", justifyContent:"center", padding:"8px 0" }}>
  <div style={{
    background,
    borderRadius: "16px",
    width: "calc(100% )",  // slightly smaller than container
    // maxWidth: "600px",            // optional
    height,
    display:"flex",
    flexDirection:"column",
    justifyContent:"center",
    alignItems:"center",
    padding:"12px",
    pointerEvents:"none",
    ...style
  }}>
    {spinner && <MultiOrbitSpinner3 color="white" size="96"/>}
    {text && <span style={{ marginTop: spinner ? "0.5rem" : 0 }}>{text}</span>}
  </div>
</div>


);


}
